<span class="circle" [class]="variant()" [title]="name()">
    @if (icon()) {
        <mat-icon class="icon" [svgIcon]="icon()" aria-hidden="true" />
    } @else {
        <span class="initials">{{ initials() }}</span>
    }
</span>
